import { useContext } from 'react';
import { SvgIcon } from '../../../common/components/SvgIcon';
import { useSgwtTranslation } from '../../../common/i18n';
import { BotConversationContext } from '../shared/BotConversationContext';
import type { SgwtChatbotConversation } from '../shared/chatbot.types';
import { ChatBody } from './layout/ChatBody';
import { MessageContent } from './MessageContent';

const dateFormatter = new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' });

const ExistingConversation = ({ conversation }: { conversation: SgwtChatbotConversation }) => {
  const { switchToConversation } = useContext(BotConversationContext);

  const continueConversation = () => {
    switchToConversation(conversation.conversationId);
  };

  return (
    <button
      type="button"
      className="list-group-item list-group-item-action list-group-item-secondary border-bottom border-opacity-40 px-2"
      onClick={continueConversation}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex flex-column align-items-start gap-2">
          <MessageContent message={conversation.messages[0].message} className="text-primary text-break" />
          <span className="text-secondary fs-12">{dateFormatter.format(new Date(conversation.metadata.created))}</span>
        </div>
        <div className="d-flex align-items-center">
          <SvgIcon type="keyboard_arrow_right" className="icon" height={16} width={16} />
        </div>
      </div>
    </button>
  );
};

export const ChatHistory = () => {
  const { translate } = useSgwtTranslation();
  const { history, startNewConversation } = useContext(BotConversationContext);

  return (
    <ChatBody>
      <div className="sgwt-chatbot-history flex-grow-1 d-flex flex-column">
        <button type="button" className="btn btn-default btn-lg btn-icon-end w-100" onClick={startNewConversation}>
          {translate('create.conversation')}
          <SvgIcon type="add_comment" />
        </button>
        {
          // History not loaded yet
          history === undefined ? (
            <div className="flex-fill flex-column flex-center-x text-secondary m-auto text-center" style={{ width: '75%' }}>
              <div className="spinner spinner-lg mb-3" />
              <p>{translate('loading')}</p>
            </div>
          ) : // Not history entries
          history.length === 0 ? (
            <div className="flex-fill flex-column flex-center-x text-secondary m-auto text-center" style={{ width: '75%' }}>
              <SvgIcon type="history" className="icon" height={32} width={32} />
              <h4 className="mt-2">{translate('history.empty.title')}</h4>
              <p>{translate('history.empty.text')}</p>
            </div>
          ) : (
            <ul className="list-group mt-3">
              {history.map((conversation) => (
                <ExistingConversation key={conversation.conversationId} conversation={conversation} />
              ))}
            </ul>
          )
        }
      </div>
    </ChatBody>
  );
};
